import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_CATEGORIES_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/categories',
        iconClass: 'fas fa-list',
        name: 'Categories',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.Categories',
        order: 4
      },
    ]);
  };
}
